/*
Copyright 2025 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const TextSpaceAfterIcon = ({
  width = 24,
  height = 24,
  hidden = false,
  title = 'Text Space After',
} = {}): string | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    height="${height}"
    viewBox="0 0 36 36"
    width="${width}"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <rect height="4" rx="1" ry="1" width="20" x="14" y="8" />
    <rect height="4" rx="1" ry="1" width="20" x="14" y="14" />
    <rect height="4" rx="1" ry="1" width="20" x="14" y="2" />
    <path
      d="M4 33.328a.5.5 0 0 0 .866.341L10 28l-5.134-5.669a.5.5 0 0 0-.866.341ZM34 33V23a1 1 0 0 0-1-1H15a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h18a1 1 0 0 0 1-1Zm-2-1H16v-8h16Z"
    />
  </svg>`;
};
